import APPLICATION_CONSTANTS from '../applicationConstants';
import { SearchFilterGroups } from '../constants';

/**
 * 
 * @param {*} filterGroup 
 * @param {*} values 
 * @param {*} t 
 * @returns 
 */
export function fixGroupName(filterGroup, values, t) {
  let filterGroupFormatted = formatDisplayName(filterGroup, t);
  const textMapping = APPLICATION_CONSTANTS.GLOBAL.EXPERT_TEXT_MAP;

  if (values?.length === 1) {
    if ((filterGroupFormatted === SearchFilterGroups.badges || filterGroupFormatted === SearchFilterGroups.filters) && textMapping[values]) {
      filterGroupFormatted = textMapping[values];
    }
    else if (filterGroup === SearchFilterGroups.offers) {
      filterGroupFormatted = getInnerTextFromHtmlString(values);
    }
  }

  return filterGroupFormatted;
}

export function getSelectedFilters(selectedFilters,filterType,tenantSpecificFiltersState){
  const tenantFiltersSelections = ['Badges', 'Filters', 'Offers', 'Brands'];
  let genericFilters = [];
  let validatedTenantSpecificFilter = {};
  if(tenantSpecificFiltersState){
    const tenantSpecificFilter = [];
    for(const index in selectedFilters){
      if(tenantFiltersSelections.includes(selectedFilters[index].key)){
        tenantSpecificFilter.push(selectedFilters[index]);
      }else{
        genericFilters.push(selectedFilters[index]);
      }
    }
    validatedTenantSpecificFilter = validateTenantSpecificFilters(tenantSpecificFilter,tenantSpecificFiltersState);
  }else{
    genericFilters = selectedFilters;
  }
  if(filterType === 'tenant_specific'){
    return validatedTenantSpecificFilter;
  }
  if(filterType === 'generic'){
    return genericFilters;
  }
  return null;
}

export function validateTenantSpecificFilters(tenantSpecificFilters, tenantSpecificFiltersState ) {
  const validatedFilters = {};
  for(const index in tenantSpecificFilters){
    const currentFilter = tenantSpecificFilters[index];
    if(currentFilter.values?.length){
      let currentFilterValue = currentFilter.values;
      //for backwards compatability
      if(currentFilterValue[0] === 'Yes') {
        currentFilterValue = tenantSpecificFiltersState[currentFilter.key];
      }
      else {
        //iterate through filter values and determine if its indexed Yes (Yes0, Yes1)
        for(const currentItemIndexInFilterValueCollecttion in currentFilterValue) {
          const currentItemInFilterValueCollecttion = currentFilterValue[currentItemIndexInFilterValueCollecttion];
          const startsWithYes = currentItemInFilterValueCollecttion.startsWith('Yes');
          if(startsWithYes) {
            const parsedIndex = currentItemInFilterValueCollecttion.substr('Yes'.length);
            if(tenantSpecificFiltersState[currentFilter.key][parsedIndex]) {
              currentFilterValue[currentItemIndexInFilterValueCollecttion] = tenantSpecificFiltersState[currentFilter.key][parsedIndex];
            }
          } 
        }
      }
      validatedFilters[currentFilter.key] = currentFilterValue;
    }
  }
  return validatedFilters;
}

export function stripNullValuesFromFilter(filterArray) {
  const results = filterArray.filter((element) => {
    return typeof element === 'object' && element !== null;
  });
  return results;
}

/**
 * 
 * @param {*} filterName 
 * @param {*} t 
 * @returns 
 */
export function formatDisplayName(filterName, t) {
  let formattedDisplayName = filterName.replace(/[()]/g, '');
  formattedDisplayName = formattedDisplayName.replace(/[_]/g, ' ');
  formattedDisplayName = `${formattedDisplayName.charAt(0).toUpperCase() + formattedDisplayName.slice(1)}`;

  if (filterName === SearchFilterGroups.onlineBooking && t('text_online_booking')) {
    formattedDisplayName = t('text_online_booking');
  }

  return formattedDisplayName;
}

/**
 *
 * @param {*} filterName
 * @param {*} t
 * @param {*} i18n
 * @returns
 */
export function formatFilterName(filterName, t, i18n) {
  let formattedFilterName = '';
  const textMapping = APPLICATION_CONSTANTS.GLOBAL.EXPERT_TEXT_MAP;
  const safeFilterName = filterName.toLowerCase();
  const translationKey = `text_${safeFilterName}`;
  const translatedFilterNameMapping = { // TODO: need to change this to a more generic way
    'Tab': t('text_book_now', 'Book an eye exam'),
    'TabLite': t('text_book_in_store_services_filter', 'Book in-store services'),
    'Wholesale': t('text_book_exam', 'Book an appointment'),
  };
 
  if (i18n.exists(translationKey)) {
    formattedFilterName = t(translationKey);
  } else if (Object.keys(translatedFilterNameMapping).includes(filterName)) {
    formattedFilterName = t(`${translatedFilterNameMapping[filterName]}`);
  } else if (Object.keys(textMapping).includes(filterName)) {
    formattedFilterName = textMapping[filterName];
  }
  else {
    formattedFilterName = formatDisplayName(filterName, t);
  }
  
  return formattedFilterName;
}

export function getInnerTextFromHtmlString(htmlString) {
  const domParser = new DOMParser();
  const document = domParser.parseFromString(htmlString, 'text/html');
  const convertedHtmlStringElement = document.body;

  return convertedHtmlStringElement.innerText;
}

/**
 * 
 * @param {*} filterKey 
 * @param {*} t 
 * @param {*} i18n 
 * @returns 
 */
export function translateFilterHeaders(filterKey, t, i18n) {
  let formattedDisplayName = filterKey;

  // The current approach of converting the Segments filter header to Offers works, 
  // but there might be more efficient or cleaner ways to achieve the same result. 
  if (filterKey === 'Segments') {
    formattedDisplayName = 'Offers';
  }

  const filterKeyMapping = {
    'Filters': 'text_filter_plural'
  };

  if (filterKey in filterKeyMapping) {
    formattedDisplayName = t(filterKeyMapping[filterKey]);
  }

  const safeFilterGroupName = formattedDisplayName.toLowerCase();
  const translationKey = `text_${safeFilterGroupName}`;

  if (i18n.exists(translationKey)) {
    formattedDisplayName = t(translationKey);
  }

  const secondTranslationKey = `text_filter_${safeFilterGroupName}`;
  
  if (i18n.exists(secondTranslationKey)) {
    formattedDisplayName = t(secondTranslationKey);
  }

  return formattedDisplayName;
}

export function getDefaultSearchDistanceRadius(config) {
  return window.locatorTenancy.searchDistanceRadius ?? config.search_distance_radius;
}

export function disableAvailableFilterValue(config, availableFilters) {
  let updatedAvailableFilters = null;

  // Forcefully disables Tab booking for retail stores.
  if (config?.disable_retail_booking) {
    updatedAvailableFilters = availableFilters.map((item) => {
      if (item.key === 'ServiceType') {
        return {
          ...item,
          values: item?.values.filter((value) => value !== 'Tab')
        };
      }

      return item;
    });
  } 
  
  // Forcefully disables Service Type filter.
  if (config?.disable_service_type_filter) {
    updatedAvailableFilters = availableFilters.filter((item) => {
      return item.key != 'ServiceType';
    });
  } 

  return updatedAvailableFilters ? updatedAvailableFilters : availableFilters;
}
